 export function handleResponseArray<T>(response: unknown): T[] {
    if (!response) {
        return [];
    }
    if (!Array.isArray(response)) {
        return [];
    }
    return response
}